import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import IMG01 from '../../../assets/images/patients/patient2.jpg';
import qrTempImg from '../../../assets/images/qrTempImg.png';
import axios from 'axios';
import { API_CONFIG } from '../../../../Config/config-env.js';
import { getMensajes,getPlans, getValoresXDominio, getDays, findObjName, find, getCookie, getMonths, getPaises, getYears, getPaymentStatus, RegClienteSAP,RegClienteOld, getClienteByCI, validateForm, getPlansv2, getShopCartSessionCode, decodeToken } from '../../functions.js';
import Loader from "../../Loader";
import DialogBenef from "../../DialogBenef";
import { toast, ToastContainer, MDBFormInline, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput, MDBIcon } from 'mdbreact';

var refreshing = false;
var tryOuts = 0;
/*
var qrPayed="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";
*/
class Checkout extends Component {

	constructor(props) {
		super(props);
		this.state = {
			modalConfirm: false, 
			DocIdentidadAsesor: null,
			tokenAsesor: null,
			nombreAsesor: null,
			tieneBenef:2,
			isExecuting: true,
			showFrame: false,//false,
			showWarning: false,
			modalB: false,
			buttonsModalB: [
				{
					buttonAction: this.addBeneficiario,
					buttonId: 1,
					buttonClass: "btn btn-success btn-sm",
					buttonName: "Guardar Beneficiario"
				}
			],
			messageOrder: "",
			estadoscivil:[
				{ text: "SOLTERO(A)", value: "SOLTERO(A)" },
				{ text: "CASADO(A)", value: "CASADO(A)" },
				{ text: "VIUDO(A)", value: "VIUDO(A)" },
				{ text: "DIVORCIADO(A)", value: "DIVORCIADO(A)" },
			],
			maxTryOuts: 60,
			orderError: false,
			orderTimeOut: false,
			disabledPayButton: false,
			buttonMessage: "Generar Codigo QR",
			generatedqrCode: false,
			shopCartSessionID: "",
			terminos:"NO",
			newShopCartSessionID: "",
			mensaje_facturacion: "",
			errorMessage: "",
			v_extension_T: [
				{ text: "BE", value: "BE" },
				{ text: "CB", value: "CB" },
				{ text: "LP", value: "LP" },
				{ text: "OR", value: "OR" },
				{ text: "PD", value: "PD" },
				{ text: "PT", value: "PT" },
				{ text: "SC", value: "SC" },
				{ text: "CH", value: "CH" },
				{ text: "TJ", value: "TJ" },
				{ text: "N/A", value: "" }
			],
			processingPayment: false,
			showError: false,
			switch: false,
			lockPatientInfo: false,
			orderPaid: false,
			/*datos a modificar*/

			//isInvalid_user_name:false, 

			

			amount: "0.00",

			titular_radioGenero: 1,
			benef_radioGenero: 1,
			radioGenero: 1,

			
			tipo: "N",

			card_name: "",
			card_lastname: "",
			card_number: "",
			card_month: "",
			card_year: "",
			cvv: "",			
			
			extension: "",
			expedicion: "",
			ciudad: "BENI",
			pais: "BOLIVIA",
			titular_extension: "",
			titular_expedicion: "",
			titular_id_cliente: "",		
			ocupacion: "",
			estadocivil: "SOLTERO(A)",
			titular_ciudad: "BENI",
			titular_pais: "BOLIVIA",
			benef_ciudad: "BENI",
			benef_pais: "BOLIVIA",
			benef_parentesco: "ESPOSA",
			titular_TipoDoc: "C",
			benef_extension: "",
			benef_expedicion: "BE",
			qrDim:300,
			user_name: "",
			day: "",
			month: "",
			year: "",
			last_name: " ",
			email: "",
			phone: "0",
			ci_cliente: "",
			direccion: "NA",		
			titular_ci_cliente: "",
			titular_user_name: "",
			titular_last_name: "",
			titular_last_name_2: "",
			titular_email: "",
			titular_phone: "0",
			titular_day: "",
			titular_month: "",
			titular_year: "",
			titular_direccion: "NA",
			last_name_2: "",
			nombre_factura: "",
			nit: "",			
			titular_ocupacion: "",
			titular_estadocivil: "SOLTERO(A)",			
			benef_ocupacion: "",
			benef_estadocivil: "SOLTERO(A)",
			benef_ci_cliente: "",
			benef_id_cliente: "",
			benef_user_name: "",
			benef_last_name: "",
			benef_last_name_2: "",
			benef_email: "",
			benef_phone: "",
			benef_day: "",
			benef_month: "",
			benef_year: "",
			benef_direccion: "",
			

			
			
			benef_edit: -1,
			v_beneficiarios: [],

			v_days: [],
			v_months: [],
			v_years: [],
			v_days_T: [],
			v_months_T: [],
			v_years_T: [],

			costo: 0,
			descuento: 0,
			fechaActual: "",
			horaActual: "",
			nombre_producto: "",
			isCorrect: true,
			productType: "",
			paymentKey: "",
			productId: 0,
			productos: [],

			windowWidth: 320,
			//radioPaymentType: 1,
			radioPaymentType: 2,
			defQR: "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",

			validation: [
				{ name: 'ci_cliente', label: 'Carnet de Identidad del Contratante', invalid: false, type: "number", /*notRequired: true,*/ maxLength: 12, minLength: 5 },
				{ name: 'user_name', label: 'Nombre del Contratante', invalid: false, type: "text" },
				{ name: 'last_name', label: 'Apellido del Contratante', invalid: false, type: "text" },
		//		{ name: 'phone', label: 'Numero de Celular del Contratante', invalid: false, type: "phone" },
		//		{ name: 'email', label: 'Email del Contratante', invalid: false, type: "email", notRequired: true },
				{ name: 'day', label: 'Dia de Nacimiento del Contratante', invalid: false, type: "text" },
				{ name: 'month', label: 'Mes de Nacimiento del Contratante', invalid: false, type: "text" },
				{ name: 'year', label: 'A\u00F1o de Nacimiento del Contratante', invalid: false, type: "number" },
				{ name: 'nombre_factura', label: 'Nombre para la Factura del Contratante', invalid: false, type: "text" },
				{ name: 'nit', label: 'Nit del Contratante', invalid: false, type: "number" },
				{ name: 'expedicion', label: 'Expedici\u00F3n del Contratante', invalid: false, type: "text",notRequired: true   },
				{ name: 'tipo', label: 'Tipo Persona del Contratante', invalid: false, type: "text" },
				{ name: 'pais', label: 'Pais', invalid: false, type: "text" },
				{ name: 'ciudad', label: 'Ciudad', invalid: false, type: "text" },
		//		{ name: 'direccion', label: 'Direccion', invalid: false, type: "text" },				
			//	{ name: 'ocupacion', label: 'Ocupacion', invalid: false, type: "text" },
		//		{ name: 'estadocivil', label: 'Estado Civil', invalid: false, type: "text" },
			],

			validation_T: [
				{ name: 'titular_ci_cliente', label: 'Carnet de Identidad del Titular', invalid: false, type: "number", maxLength: 12, minLength: 5 },
				{ name: 'titular_user_name', label: 'Nombre del Titular', invalid: false, type: "text" },
				{ name: 'titular_last_name', label: 'Apellido del Titular', invalid: false, type: "text" },
		//		{ name: 'titular_phone', label: 'Numero de Celular del Titular', invalid: false, type: "phone" },
		//		{ name: 'titular_email', label: 'Email del Titular', invalid: false, type: "email", notRequired: true },
				{ name: 'titular_day', label: 'Dia de Nacimiento del Titular', invalid: false, type: "text" },
				{ name: 'titular_month', label: 'Mes de Nacimiento del Titular', invalid: false, type: "text" },
				{ name: 'titular_year', label: 'A\u00F1o de Nacimiento del Titular', invalid: false, type: "number" },
				{ name: 'titular_expedicion', label: 'Expedici\u00F3n del Titular', invalid: false, type: "text",  notRequired: true  },
		//		{ name: 'titular_direccion', label: 'Direccion\u00F3n del Titular', invalid: false, type: "text" },
				{ name: 'titular_pais', label: 'Pais', invalid: false, type: "text" },
				{ name: 'titular_ciudad', label: 'Ciudad', invalid: false, type: "text" },
			//	{ name: 'titular_ocupacion', label: 'Ocupacion', invalid: false, type: "text" },
				{ name: 'titular_estadocivil', label: 'Estado Civil', invalid: false, type: "text" },

			],

			validation_B: [
				{ name: 'benef_ci_cliente', label: 'Carnet de Identidad del Beneficiario', invalid: false, type: "number", maxLength: 12, minLength: 5 },
				{ name: 'benef_user_name', label: 'Nombre del Beneficiario', invalid: false, type: "text" },
				{ name: 'benef_last_name', label: 'Apellido del Beneficiario', invalid: false, type: "text" },
			//	{ name: 'benef_phone', label: 'Numero de Celular del Beneficiario', invalid: false, type: "phone" },
			//	{ name: 'benef_email', label: 'Email del Beneficiario', invalid: false, type: "email", notRequired: true },
				{ name: 'benef_day', label: 'Dia de Nacimiento del Beneficiario', invalid: false, type: "text" },
				{ name: 'benef_month', label: 'Mes de Nacimiento del Beneficiario', invalid: false, type: "text" },
				{ name: 'benef_year', label: 'A\u00F1o de Nacimiento del Beneficiario', invalid: false, type: "number" },
				{ name: 'benef_expedicion', label: 'Expedici\u00F3n del Beneficiario', invalid: false, type: "text",  notRequired: true  },
			//	{ name: 'benef_direccion', label: 'Direccion\u00F3n del Beneficiario', invalid: false, type: "text" },
				{ name: 'benef_pais', label: 'Pais', invalid: false, type: "text" },
				{ name: 'benef_ciudad', label: 'Ciudad', invalid: false, type: "text" },
				{ name: 'benef_parentesco', label: 'Parentezco', invalid: false, type: "text" },
			//	{ name: 'benef_ocupacion', label: 'Ocupacion', invalid: false, type: "text" },
				{ name: 'benef_estadocivil', label: 'Estado Civil', invalid: false, type: "text" },
			],

			validation2: [
				{ name: 'card_name', label: 'Nombre del Titular de la Tarjeta', invalid: false, type: "text" },
				{ name: 'card_lastname', label: 'Apellido del Titular de la Tarjeta', invalid: false, type: "text" },
				{ name: 'card_number', label: 'Numero de la Tarjeta', invalid: false, type: "number" },
				{ name: 'card_month', label: 'Mes del Titular de la Tarjeta', invalid: false, type: "number" },
				{ name: 'card_year', label: 'A\u00F1o del Titular de la Tarjeta', invalid: false, type: "number" },
				{ name: 'cvv', label: 'CVV', invalid: false, type: "number" }
			],
			paises: [],
			ciudades: [
				{ text: "BENI", value: "BENI" },
				{ text: "COCHABAMBA", value: "COCHABAMBA" },
				{ text: "CHUQUISACA", value: "CHUQUISACA" },
				{ text: "LA PAZ", value: "LA PAZ" },
				{ text: "ORURO", value: "ORURO" },
				{ text: "PANDO", value: "PANDO" },
				{ text: "POTOS\U00ED", value: "POTOS\U00ED" },
				{ text: "SANTA CRUZ", value: "SANTA CRUZ" },
				{ text: "TARIJA", value: "TARIJA" },
				{ text: "OTRO", value: "OTRO" }
			],

			parentescos: [
				{ text: "Esposa", value: "Esposa" },
				{ text: "Esposo", value: "Esposo" },
				{ text: "Hijo", value: "Hijo" },
				{ text: "Hija", value: "Hija" },
				{ text: "Hermano", value: "Hermano" },
				{ text: "Hermana", value: "Hermana" },
			],
			tipos: [
				{ text: "Natural", value: "N" },
				{ text: "Juridica", value: "J" },
			]
		}
	}
	onClickTerminos = (event) => {

		if (this.state.terminos === "SI") {
			this.setState({
				...this.state,
				terminos: "NO"
			});
		} else {
			this.setState({
				...this.state,
				terminos: "SI"
			});
		}
	};

	showAddBeneficiario = (event) => {

		this.setState({
			modalB: true,
			benef_edit: -1
		});
	};

	toggleB = (event) => {
		this.setState({
			['modalB']: !this.state['modalB']
		});
	}

	onClickRadio = nr => () => {
		if (nr === 1) {
			this.setState({
				...this.state,
				radioPaymentType: nr,
				buttonMessage: "Confirmar y Pagar"
			});
		} else if (nr === 2) {
			this.setState({
				...this.state,
				radioPaymentType: nr,
				buttonMessage: "Generar Codigo QR"
			});
		} else if (nr === 3) {
			this.setState({
				...this.state,
				radioPaymentType: nr,
				buttonMessage: "Confirmar y Pagar"
			});
		}
	};

	onClickRadioGen = nr => () => {
		this.setState({
			radioGenero: nr
		});
	};

	onClickRadioGen_T = nr => () => {
		this.setState({
			titular_radioGenero: nr
		});
	};

	onClickRadioGen_B = nr => () => {
		//console.log("change", nr)
		this.setState({
			benef_radioGenero: nr
		});
	};
 
	changeHandler = async (event) => {

		var field_value = event.target.value
		var field_name = event.target.name
		var respVal = validateForm(this.state.validation, this.state, toast, field_name, field_value)
		this.setState({ ...this.state, [event.target.name]: event.target.name==="email"?event.target.value: (event.target.value).toUpperCase()  , validation: respVal.validation });
		
		if (event.target.name=="pais"){
			if (event.target.value!="BOLIVIA"){
				setTimeout(function () { 
					this.setState({ ...this.state, ciudad: ""  });
				}.bind(this), 10);
			}else{
				setTimeout(function () { 
					this.setState({ ...this.state, ciudad: "Beni"  });
				}.bind(this), 10);
			}
		}
		
		if (field_name === "ci_cliente") {

			/*
			if (field_value.length>=6 && field_value.length<=12){
			  var resp = await getClienteByCI(field_value);
			  
			  if(resp.bloquear_datos){
			  	
						var validation = [
								{name:'ci_cliente', 		label:'Carnet de Identidad del Paciente'       , invalid:false, type:"number", notRequired:true,maxLength:8, minLength:5 },
								{name:'user_name',  		label:'Nombre del Paciente'                    , invalid:false, type:"text" },
								{name:'last_name', 			label:'Apellido del Paciente'                  , invalid:false, type:"text"   },
								{name:'phone',      		label:'Numero de Celular del Paciente'         , invalid:false, type:"phone"  }		,
								{name:'email'   , 		  label:'Email del Paciente'                     , invalid:false, type:"email" , notRequired:true},
								{name:'day',            label:'Dia de Nacimiento del Paciente'					, invalid:false, type:"text"},
								{name:'month',          label:'Mes de Nacimiento del Paciente'					, invalid:false, type:"text"},
								{name:'year',           label:'A\u00F1o de Nacimiento del Paciente'		, invalid:false, type:"number"},				
							{name:'nombre_factura', label:'Nombre para la Factura del Paciente'		, invalid:false, type:"text" },
								{name:'nit' ,           label:'Nit del Paciente'                   		, invalid:false, type:"number"}
					];
					this.setState({ ...this.state, validation:validation});  
					
					this.setState({ ...this.state,
								  //lockPatientInfo:resp.bloquear_datos,
								  user_name:resp.nombre_cliente,
								  last_name:resp.apellido_paterno,
								  last_name_2:resp.apellido_materno,
								  radioGenero:  resp.radioGenero,
								  phone: resp.telefono_cliente,
								  email: resp.email_cliente,
								  id_cliente: resp.id_cliente,
								  TipoDoc: resp.TipoDoc,
								  year: resp.FechaNaci?resp.FechaNaci.substr(0,4):"",
													month:resp.FechaNaci?resp.FechaNaci.substr(4,2):"",
													day:resp.FechaNaci?resp.FechaNaci.substr(6,2):"" ,
													ci_afiliado:  resp.ci_afiliado,
													Tipo_doc_afiliado: resp.Tipo_doc_afiliado,
													Id_afiliado: resp.Id_afiliado,
												})
												
					if (resp.Id_afiliado!=""){ 
						let respT = await getClienteByCI(resp.ci_afiliado, resp.tipo_doc);
						if(respT.bloquear_datos){
							
							var validation_T = [
										{name:'titular_ci_cliente',     label:'Carnet de Identidad del Titular' 		,invalid:false, type:"number",  maxLength:8, minLength:5},
										{name:'user_titular_name',  		label:'Nombre del Titular'              		,invalid:false, type:"text"},
										{name:'titular_last_name',			label:'Apellido Paterno del Titular'    		,invalid:false, type:"text"},
										{name:'titular_phone',					label:'Numero de Celular del Titular'   		,invalid:false, type:"phone"},
										{name:'titular_email',					label:'Email del Titular'               		,invalid:false, type:"email",  notRequired:true},
										{name:'titular_day',            label:'Dia de Nacimiento del Titular'				, invalid:false, type:"text"},
										{name:'titular_month',          label:'Mes de Nacimiento del Titular'				, invalid:false, type:"text"},
										{name:'titular_year',           label:'A\u00F1o de Nacimiento del Titular'	, invalid:false, type:"number"}	
								];
							 this.setState({ ...this.state, validation_T:validation_T});   
							 this.setState({ ...this.state,
									  //lockPatientInfo:respT.bloquear_datos,
									  titular_id_cliente: respT.id_cliente,
														titular_TipoDoc: respT.TipoDoc,
									  titular_user_name:respT.nombre_cliente,
									  titular_last_name:respT.apellido_paterno,
									  titular_last_name_2:respT.apellido_materno,
									  titular_radioGenero:  respT.radioGenero,
									  titular_phone: respT.telefono_cliente,
									  titular_email: respT.email_cliente,
									  titular_year: respT.FechaNaci?respT.FechaNaci.substr(0,4):"",
														titular_month:respT.FechaNaci?respT.FechaNaci.substr(4,2):"",
														titular_day:respT.FechaNaci?respT.FechaNaci.substr(6,2):"",
							  });    	
					  } 	
					}
			  }
			  
			  
			  
			}*/
		}
	};
	changeHandler_T = async (event) => {

		var field_value = event.target.value
		var field_name = event.target.name
		var respVal = validateForm(this.state.validation_T, this.state, toast, field_name, field_value)
		this.setState({ ...this.state, [event.target.name]: event.target.name==="titular_email"?event.target.value: (event.target.value).toUpperCase()  , validation_T: respVal.validation });

		if (event.target.name=="titular_pais"){
			if (event.target.value!="BOLIVIA"){
				setTimeout(function () { 
					this.setState({ ...this.state, titular_ciudad: ""  });
				}.bind(this), 10);
			}else{
				setTimeout(function () { 
					this.setState({ ...this.state, titular_ciudad: "Beni"  });
				}.bind(this), 10);
			}
		}
		

		if (field_name === "titular_ci_cliente") {
			/*
			if (field_value.length >= 6 && field_value.length <= 8) {
				var resp = await getClienteByCI(field_value);

				if (resp.bloquear_datos) {
					var validation_T = [
						{ name: 'titular_ci_cliente', label: 'Carnet de Identidad del Titular', invalid: false, type: "number", maxLength: 8, minLength: 5 },
						{ name: 'titular_user_name', label: 'Nombre del Titular', invalid: false, type: "text" },
						{ name: 'titular_last_name', label: 'Apellido Paterno del Titular', invalid: false, type: "text" },
						{ name: 'titular_phone', label: 'Numero de Celular del Titular', invalid: false, type: "phone" },
						{ name: 'titular_email', label: 'Email del Titular', invalid: false, type: "email", notRequired: true },
						{ name: 'titular_day', label: 'Dia de Nacimiento del Titular', invalid: false, type: "text" },
						{ name: 'titular_month', label: 'Mes de Nacimiento del Titular', invalid: false, type: "text" },
						{ name: 'titular_year', label: 'A\u00F1o de Nacimiento del Titular', invalid: false, type: "number" }
					];
					this.setState({ ...this.state, validation_T: validation_T });
				}
				this.setState({
					...this.state,
					//lockPatientInfo:resp.bloquear_datos,
					titular_id_cliente: resp.id_cliente,
					titular_TipoDoc: resp.TipoDoc,
					titular_user_name: resp.nombre_cliente,
					titular_last_name: resp.apellido_paterno,
					titular_last_name_2: resp.apellido_materno,
					titular_radioGenero: resp.radioGenero,
					titular_phone: resp.telefono_cliente,
					titular_email: resp.email_cliente,
					titular_year: resp.FechaNaci ? resp.FechaNaci.substr(0, 4) : "",
					titular_month: resp.FechaNaci ? resp.FechaNaci.substr(4, 2) : "",
					titular_day: resp.FechaNaci ? resp.FechaNaci.substr(6, 2) : "",
				});
			}
			*/
		}
	};

	changeHandler_B = async (event) => {

		var field_value = event.target.value
		var field_name = event.target.name
		//console.log(field_value)
		var respVal = validateForm(this.state.validation_B, this.state, toast, field_name, field_value)
		this.setState({ ...this.state, [event.target.name]: event.target.name==="benef_email"?event.target.value: (event.target.value).toUpperCase(), validation_B: respVal.validation });

 
		if (event.target.name=="benef_pais"){
			if (event.target.value!="BOLIVIA"){
				console.log("no es")
				setTimeout(function () { 
					this.setState({ ...this.state, benef_ciudad: ""  });
				}.bind(this), 10);
			}else{
				setTimeout(function () { 
					this.setState({ ...this.state, benef_ciudad: "Beni"  });
				}.bind(this), 10);
			}
		}
		
		if (field_name === "benef_ci_cliente") {
			/*
			if (field_value.length >= 6 && field_value.length <= 8) {
				var resp = await getClienteByCI(field_value);
_value);

				if (resp.bloquear_datos) {
					var validation_B = [
						{ name: 'benef_ci_cliente', label: 'Carnet de Identidad del Beneficiario', invalid: false, type: "number", maxLength: 8, minLength: 5 },
						{ name: 'benef_user_name', label: 'Nombre del Beneficiario', invalid: false, type: "text" },
						{ name: 'benef_last_name', label: 'Apellido Paterno del Beneficiario', invalid: false, type: "text" },
						{ name: 'benef_phone', label: 'Numero de Celular del Beneficiario', invalid: false, type: "phone" },
						{ name: 'benef_email', label: 'Email del Beneficiario', invalid: false, type: "email", notRequired: true },
						{ name: 'benef_day', label: 'Dia de Nacimiento del Beneficiario', invalid: false, type: "text" },
						{ name: 'benef_month', label: 'Mes de Nacimiento del Beneficiario', invalid: false, type: "text" },
						{ name: 'benef_year', label: 'A\u00F1o de Nacimiento del Beneficiario', invalid: false, type: "number" }
					];
					this.setState({ ...this.state, validation_B: validation_B });
				}
				this.setState({
					...this.state,
					//lockPatientInfo:resp.bloquear_datos,
					benef_id_cliente: resp.id_cliente,
					benef_TipoDoc: resp.TipoDoc,
					benef_user_name: resp.nombre_cliente,
					benef_last_name: resp.apellido_paterno,
					benef_last_name_2: resp.apellido_materno,
					benef_radioGenero: resp.radioGenero,
					benef_phone: resp.telefono_cliente,
					benef_email: resp.email_cliente,
					benef_year: resp.FechaNaci ? resp.FechaNaci.substr(0, 4) : "",
					benef_month: resp.FechaNaci ? resp.FechaNaci.substr(4, 2) : "",
					benef_day: resp.FechaNaci ? resp.FechaNaci.substr(6, 2) : "",
				});
			}
			*/
		}
	};



	changeHandler_C = async (event) => {

		var field_value = event.target.value
		var field_name = event.target.name
		var respVal = validateForm(this.state.validation2, this.state, toast, field_name, field_value)
		this.setState({ ...this.state, [event.target.name]: (event.target.value).toUpperCase(), validation2: respVal.validation });
	};

	handleResize = () => {
		 
			let qrDim = 520
			if (window.innerWidth<560){
				qrDim = window.innerWidth-70
			}
		this.setState({
			windowWidth: window.innerWidth,
			qrDim : qrDim
		})
	};

	componentDidMount = async () => {
		
		if (process.env.REACT_APP_DEF_DATA){
			this.setDefData()
		}

		this.handleResize();
		window.removeEventListener("resize",this.handleResize );
		window.addEventListener("resize", this.handleResize);
		var intervalId = setInterval(this.refreshPaymentState, 3000);
		var productType = this.props.match.params.productType;

		var respMensajes = await getMensajes()
		var paises = getPaises()
		const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
		const f = new Date();

		var fechaActual = ((f.getDate()) < 10 ? "0" + (f.getDate()) : (f.getDate())) + " " + MESES[f.getMonth()] + " " + f.getFullYear();

		var hora = f.getHours()
		var minuto = (f.getMinutes()) < 10 ? "0" + (f.getMinutes()) : (f.getMinutes())

		if (hora > 12) {
			hora = (hora - 12) + ":" + minuto + " PM"
		} else if (hora === 0) {
			hora = "12" + ":" + minuto + " AM"
		} else if (hora === 12) {
			hora = "12" + ":" + minuto + " PM"
		} else {
			hora = hora + ":" + minuto + " AM"
		}
		var v_days = getDays();
		var v_months = getMonths();
		var v_years = getYears();

		var respTimeOut = await getValoresXDominio("tiempo_cron");
		var maxTryOuts = respTimeOut.rows[0].valor_numerico * 60 / 3

		var Canal="C002"
		
		var tokenAsesor = getCookie("tokenINNOVA2")
		var nombreAsesor = getCookie("nombreUsuarioINNOVA2")
		var DocIdentidadAsesor = getCookie("ciUsuarioINNOVA2")
		
		var _resp = await decodeToken (tokenAsesor)
		
		if (_resp.resp=="OK"){
			var userInfo = _resp.datos
			Canal = userInfo.canal
		}
  	 
		this.setState({
			...this.state,
			intervalId: intervalId,
			DocIdentidadAsesor: DocIdentidadAsesor,
			Canal: Canal,
			tokenAsesor: tokenAsesor,
			nombreAsesor: nombreAsesor,
			mensaje_facturacion: respMensajes.mensaje_facturacion,
			windowWidth: window.innerWidth,
			isExecuting: true,
			productType: productType,
			fechaActual: fechaActual,
			horaActual: hora,
			v_days: v_days,
			v_months: v_months,
			v_years: v_years,
			v_days_T: v_days,
			v_months_T: v_months,
			v_years_T: v_years,
			maxTryOuts: maxTryOuts,
			paises: paises,


		});
		if (productType === "atencion") {
			var token = this.props.location.search;

			token = token.substr(3, token.length)
			var respToken = await decodeToken(token);

			if (respToken.resp === "OK") {
				var datos = respToken.datos
				var monto = datos.monto + ""
				/*var v_days = getDays(datos.FechaNaci?datos.FechaNaci.substr(0,4):"01" );
					var v_months = getMonths(datos.FechaNaci?datos.FechaNaci.value.substr(4,2):"01");
					var v_years = getYears(datos.FechaNaci?datos.FechaNaci.value.substr(6,2):"2000");*/
				this.setState({
					...this.state,
					isCorrect: false,
					radioGenero: datos.Genero,
					ci_cliente: datos.ci_cliente,
					id_cliente: datos.id_cliente,
					TipoDoc: datos.TipoDoc,
					user_name: datos.nombre_cliente,
					last_name: datos.apellido_paterno,
					last_name_2: datos.apellido_materno ? datos.apellido_materno : "",
					email: datos.email_cliente,
					phone: datos.telefono_cliente,
					nombre_producto: datos.nombre_producto,
					nombre_factura: datos.apellido_paterno,
					nit: datos.ci_cliente,
					costo: datos.costo ? datos.costo : 0,
					day: datos.FechaNaci ? datos.FechaNaci.substr(6, 2) : "01",
					month: datos.FechaNaci ? datos.FechaNaci.substr(4, 2) : "01",
					year: datos.FechaNaci ? datos.FechaNaci.substr(0, 4) : "2000",
					descuento: datos.descuento ? datos.descuento : 0,
					amount: monto.indexOf(".") > 0 ? monto : monto + ".00",
					shopCartSessionID: datos.id_sesion,
					//lockPatientInfo: true, //se elimina para que tambien pueda editarlo
					paymentKey: token,
					v_days: v_days,
					v_months: v_months,
					v_years: v_years,
					Tipo: datos.Tipo,
					Id_afiliado: datos.Id_afiliado,
					ci_afiliado: datos.ci_afiliado,
					Tipo_doc_afiliado: datos.Tipo_doc_afiliado
				});

				if (datos.ci_afiliado !== "") {
					let respT = await getClienteByCI(datos.ci_afiliado, datos.Tipo_doc_afiliado);
					//console.log(respT)
					this.setState({
						...this.state,
						titular_ci_cliente: respT.ci_cliente,
						titular_id_cliente: respT.id_cliente,
						titular_TipoDoc: respT.TipoDoc,
						titular_radioGenero: respT.radioGenero,
						titular_user_name: respT.nombre_cliente,
						titular_last_name: respT.apellido_paterno,
						titular_last_name_2: respT.apellido_materno ? respT.apellido_materno : "",
						titular_email: respT.email_cliente,
						titular_phone: respT.telefono_cliente,
						titular_year: respT.FechaNaci ? respT.FechaNaci.substr(0, 4) : "",
						titular_month: respT.FechaNaci ? respT.FechaNaci.substr(4, 2) : "",
						titular_day: respT.FechaNaci ? respT.FechaNaci.substr(6, 2) : "",
						v_days_T: v_days,
						v_months_T: v_months,
						v_years_T: v_years
					});
				} else {
					if (datos.ci_cliente !== "") {
						this.setState({
							...this.state,
							titular_radioGenero: datos.Genero,
							titular_ci_cliente: datos.ci_cliente,
							titular_id_cliente: datos.id_cliente,
							titular_TipoDoc: datos.TipoDoc,
							titular_user_name: datos.nombre_cliente,
							titular_last_name: datos.apellido_paterno,
							titular_last_name_2: datos.apellido_materno ? datos.apellido_materno : "",
							titular_email: datos.email_cliente,
							titular_phone: datos.telefono_cliente,
							titular_day: datos.FechaNaci ? datos.FechaNaci.substr(6, 2) : "01",
							titular_month: datos.FechaNaci ? datos.FechaNaci.substr(4, 2) : "01",
							titular_year: datos.FechaNaci ? datos.FechaNaci.substr(0, 4) : "2000",
							v_days_T: v_days,
							v_months_T: v_months,
							v_years_T: v_years
						});
					}
				}
				this.setState({ ...this.state, productos: [{ id_producto: datos.id_producto, tipo_producto: productType }] });
			} else {
				this.setState({ ...this.state, isCorrect: false });
			}
		} else {
			var respSesion = await getShopCartSessionCode()
			var productId = this.props.match.params.Id;

			//sartawi
			//var respPlan = {result: [ {Nombre: this.props.match.params.Id , Precio:"1" } ]} 
			var respPlan = await getPlans(productId)
			//sap
			//var respPlan = await getPlansv2(Canal, productId)
			console.log("respPlan",respPlan)
			 
			var nombre_producto = "demo";
			var costo =1;
			var tieneBenef=2
			try{
				nombre_producto= respPlan.result[0].Nombre
				costo =  respPlan.result[0].Precio
				tieneBenef = respPlan.result[0].Beneficiarios
				productId  = respPlan.result[0].Codigo
			}catch(Ex){
				console.log("no plan def")
			}

			this.setState({ ...this.state, tieneBenef: tieneBenef, productos: [{ id_producto: productId, tipo_producto: productType }] });

			this.setState({
				shopCartSessionID: respSesion.shopCartSessionID,
				nombre_producto: nombre_producto,
				costo: costo,   
				descuento:"0.00",
				amount:  costo,  
				paymentKey: respSesion.shopCartSessionID,
				productId: productId
			});
		}
		this.setState({ isExecuting: false });
	}

	componentWillUnmount = () => {
		clearInterval(this.state.intervalId);
		window.removeEventListener("resize",this.handleResize );
	}

	refreshPaymentState = () => {

		if (this.state.switch) {
			if (refreshing) {
				this.getPaymentStatus();
			}
		}
	}

	
	deleteBeneficiario = (event) => {
		var v_beneficiarios = this.state.v_beneficiarios
		var ci_benef = findObjName(event)
		let pos = find(v_beneficiarios, ci_benef, 'benef_ci_cliente')
		//console.log("ci_benef", ci_benef,pos)
		if (pos >= 0) {
			v_beneficiarios.splice(pos, 1)
			this.setState({ v_beneficiarios: v_beneficiarios })
		}
	}
	setDefData = (event) => {	
			
		
		var ci = Math.random() *  (8000000 - 2000000) + 2000000
		var ci2 = Math.random() * (8000000 - 2000000) + 2000000
		var ci3 = Math.random() * (8000000 - 2000000) + 2000000
		this.setState({ ...this.state,
			user_name: "test"+parseInt(ci),
			tipo:"N",
			day: "01",
			month: "01",
			year: "2020",
			last_name: "test"+parseInt(ci),
			email: "test@hotmail.com",
			phone: "72555555",
			ci_cliente: parseInt(ci),
			ocupacion:"ingeniero",
			direccion: "DIRECCION 222",		
			titular_ci_cliente: parseInt(ci3),
			titular_user_name: "test"+parseInt(ci),
			titular_last_name: "test"+parseInt(ci),
			titular_last_name_2: "test"+parseInt(ci),
			titular_email: "fsdfs@d.com",
			titular_phone: "72550001",
			titular_day: "01",
			titular_month: "01",
			titular_year: "2022",
			titular_direccion: "DIRECCION TITULAR",
			titular_ciudad: "Beni",
			titular_pais: "BOLIVIA",
			last_name_2: "test"+parseInt(ci),
			nombre_factura: "test"+parseInt(ci),
			nit: parseInt(ci)+"",			
			titular_ocupacion: "ingeniero",
			titular_estadocivil: "SOLTERO",			
			benef_ocupacion: "ingeniero",
			benef_estadocivil: "SOLTERO",
			benef_ci_cliente: parseInt(ci2),
			benef_id_cliente: "",
			benef_user_name: "test_benef_yvs",
			benef_last_name: "test_benef_yvs",
			benef_last_name_2: "test_benef_yvs",
			benef_email: "test_benef_yvs@test_yvs.com",
			benef_phone: "72555555",
			benef_day: "02",
			benef_month: "02",
			benef_year: "2000",
			benef_direccion: "DIRECCION BENEF",
			benef_ciudad: "BENI",
			benef_pais: "BOLIVIA",
			benef_parentesco: "ESPOSA",
		})
	}		
	
	setTitularOnContratante = (event) => {
		//console.log("setTitularOnContratante")
		this.setState({ titular_extension: this.state.extension })
		this.setState({ titular_expedicion: this.state.expedicion })
		this.setState({ titular_ci_cliente: this.state.ci_cliente })
		this.setState({ titular_id_cliente: this.state.id_cliente })
		this.setState({ titular_user_name: this.state.user_name })
		this.setState({ titular_last_name: this.state.last_name })
		this.setState({ titular_last_name_2: this.state.last_name_2 })
		this.setState({ titular_email: this.state.email })
		this.setState({ titular_phone: this.state.phone })
		this.setState({ titular_day: this.state.day })
		this.setState({ titular_month: this.state.month })
		this.setState({ titular_year: this.state.year })
		this.setState({ titular_direccion: this.state.direccion })
		this.setState({ titular_ciudad: this.state.ciudad })
		this.setState({ titular_pais: this.state.pais })
		this.setState({ titular_ocupacion: this.state.ocupacion })
		this.setState({ titular_estadocivil: this.state.estadocivil })
		this.setState({ titular_radioGenero: this.state.radioGenero })
		

	}
	showEdifBeneficiario = (event) => {

		var ci_benef = findObjName(event)


		let pos = find(this.state.v_beneficiarios, ci_benef, 'benef_ci_cliente')
		let data = this.state.v_beneficiarios[pos]

		this.setState({ benef_extension: data.benef_extension })
		this.setState({ benef_expedicion: data.benef_expedicion })
		this.setState({ benef_ci_cliente: data.benef_ci_cliente })
		this.setState({ benef_id_cliente: data.benef_id_cliente })
		this.setState({ benef_user_name: data.benef_user_name })
		this.setState({ benef_last_name: data.benef_last_name })
		this.setState({ benef_last_name_2: data.benef_last_name_2 })
		this.setState({ benef_email: data.benef_email })
		this.setState({ benef_phone: data.benef_phone })
		this.setState({ benef_day: data.benef_day })
		this.setState({ benef_month: data.benef_month })
		this.setState({ benef_year: data.benef_year })
		this.setState({ benef_direccion: data.benef_direccion })
		this.setState({ benef_ciudad: data.benef_ciudad })
		this.setState({ benef_pais: data.benef_pais })
		this.setState({ benef_radioGenero: data.benef_radioGenero })
		this.setState({ benef_parentesco: data.benef_parentesco })

		this.setState({
			modalB: true,
			benef_edit: pos
		});
	}

	addBeneficiario = async () => {

		var validate_B = true;

		var respVal_B = validateForm(this.state.validation_B, this.state, toast)
		this.setState({ ...this.state, validation_B: respVal_B.validation });
		//console.log("respVal_B", respVal_B)
		validate_B = respVal_B.isValid

		var ci_titular = this.state.titular_ci_cliente
		var ci_benef = this.state.benef_ci_cliente

		if (ci_benef == ci_titular) {
			toast.warning("Carnet de Identidad registrado para el Titular", { closeButton: true });
			validate_B = false
		}

		if (validate_B) {

			var v_beneficiarios = this.state.v_beneficiarios
			var posBenef = this.state.benef_edit
			var datosBenef = v_beneficiarios[posBenef]

			if (posBenef >= 0) {
				v_beneficiarios.map(function (key, index) {
					if (index == posBenef) {
						//console.log("es el editado",key,index)
					} else {
						//console.log("validando con el otro")
						if (key.benef_ci_cliente == ci_benef) {
							toast.warning("Carnet de Identidad ya Registrado", { closeButton: true });
							validate_B = false
						}

					}
				});

			} else {
				let pos = find(v_beneficiarios, this.state.benef_ci_cliente, 'benef_ci_cliente')
				if (pos >= 0) {
					toast.warning("Carnet de Identidad ya Registrado", { closeButton: true });
					validate_B = false
				}

			}

			if (validate_B) {
				if (posBenef >= 0) {
					v_beneficiarios[posBenef] = {
						'benef_ci_cliente': this.state.benef_ci_cliente,
						'benef_user_name': this.state.benef_user_name,
						'benef_last_name': this.state.benef_last_name,
						'benef_id_cliente': this.state.benef_id_cliente,
						'benef_last_name_2': this.state.benef_last_name_2,
						'benef_phone': this.state.benef_phone,
						'benef_email': this.state.benef_email,
						'benef_radioGenero': this.state.benef_radioGenero,
						'benef_day': this.state.benef_day,
						'benef_month': this.state.benef_month,
						'benef_year': this.state.benef_year,
						'benef_expedicion': this.state.benef_expedicion,
						'benef_direccion': this.state.benef_direccion,
						'benef_pais': this.state.benef_pais,
						'benef_ciudad': this.state.benef_ciudad,
						'benef_parentesco': this.state.benef_parentesco
					}
					this.setState({ ...this.state, v_beneficiarios: v_beneficiarios });
					toast.success("Beneficiario Actualizado Correctamente", { closeButton: true });
				} else {

					v_beneficiarios.push({
						'benef_ci_cliente': this.state.benef_ci_cliente,
						'benef_user_name': this.state.benef_user_name,
						'benef_last_name': this.state.benef_last_name,
						'benef_id_cliente': this.state.benef_id_cliente,
						'benef_last_name_2': this.state.benef_last_name_2,
						'benef_phone': this.state.benef_phone,
						'benef_email': this.state.benef_email,
						'benef_radioGenero': this.state.benef_radioGenero,
						'benef_day': this.state.benef_day,
						'benef_month': this.state.benef_month,
						'benef_year': this.state.benef_year,
						'benef_expedicion': this.state.benef_expedicion,
						'benef_direccion': this.state.benef_direccion,
						'benef_pais': this.state.benef_pais,
						'benef_ciudad': this.state.benef_ciudad,
						'benef_parentesco': this.state.benef_parentesco
					})
					toast.success("Beneficiario Agregado Correctamente", { closeButton: true });
				}
				this.setState({
					...this.state,
					benef_ci_cliente: "",
					benef_user_name: "",
					benef_last_name: "",
					benef_phone: "",
					benef_email: "",
					benef_radioGenero: 1,
					benef_day: "01",
					benef_month: "01",
					benef_year: "2000",
					benef_expedicion: "",
					//benef_direccion: "",
					benef_pais: "BOLIVIA",
					benef_ciudad: "BENI",
					benef_parentesco: "ESPOSA",
					modalB: false
				});
			}



		}

	}

	validatePaymentForm= () => {

		if (this.state.terminos === "NO") {
			toast.warning("Debe aceptar los terminos y condiciones", { closeButton: true });
		} else {

			var validate = true;
			var validate_T = true;
			var validate2 = true;
			var respVal = validateForm(this.state.validation, this.state, toast)
			var respVal_T = validateForm(this.state.validation_T, this.state, toast)
			this.setState({ ...this.state, validation: respVal.validation });

			validate = respVal.isValid
			validate_T = respVal_T.isValid

			var paymentType
			if (this.state.radioPaymentType === 1) {
				paymentType = "CYBER"
				var respVal2 = validateForm(this.state.validation2, this.state, toast)
				this.setState({ ...this.state, validation2: respVal2.validation });
				validate2 = respVal2.isValid
			} else if (this.state.radioPaymentType === 2) {
				paymentType = "QR"
			}else if (this.state.radioPaymentType === 3) {
				paymentType = "Efectivo"
			}
			
			
			if (validate && validate2 && validate_T) {
				this.setState({ ...this.state, modalConfirm:true });
			}

		}
	}

	executePayment = async () => {
		console.log("executePayment")
		if (this.state.terminos === "NO") {
			toast.warning("Debe aceptar los terminos y condiciones", { closeButton: true });
		} else {
			var validate = true;
			var validate_T = true;
			var validate2 = true;
			var respVal = validateForm(this.state.validation, this.state, toast)
			var respVal_T = validateForm(this.state.validation_T, this.state, toast)
			this.setState({ ...this.state, validation: respVal.validation });

			validate = respVal.isValid
			validate_T = respVal_T.isValid

			var paymentType
			if (this.state.radioPaymentType === 1) {
				paymentType = "CYBER"
				var respVal2 = validateForm(this.state.validation2, this.state, toast)
				this.setState({ ...this.state, validation2: respVal2.validation });
				validate2 = respVal2.isValid
			} else if (this.state.radioPaymentType === 2) {
				paymentType = "QR"
			}else if (this.state.radioPaymentType === 3) {
				paymentType = "Efectivo"
			}
			
			
			if (validate && validate2 && validate_T) {

				this.setState({ ...this.state, buttonMessage: this.state.radioPaymentType === 2 ? "Generando Codigo QR" : "Procesando Pago", isExecuting: true, processingPayment: true });
				var resp = "OK"

				//sap
				//var respPlan = await RegClienteSAP(this.state, toast);

				// sartawi
				var respPlan = await RegClienteOld(this.state, toast);
				resp = respPlan.resp;
			
				let _llave = respPlan.llave
				this.setState({ ...this.state, shopCartSessionID: respPlan.llave, paymentKey: _llave });

console.log("setPaymentOrder")
				if (resp === "OK") {
					await axios({
						url: API_CONFIG.base_url + "/payments/setPaymentOrder",
						method: 'post',
						data: {
							shopCartSessionID: this.state.shopCartSessionID,
							paymentType: paymentType,
							email: this.state.email
						}
					}).then(response => response.data)
						.then( async(data) => {
							console.log("Data", data)

							if (data.response == "OK") {
								refreshing = true;
								var order_id = data.descResponse
								this.setState({ ...this.state, showError: false, disabledPayButton: true, order_id: order_id });
								if (this.state.radioPaymentType === 1) {
									this.executePaymentCyber(order_id)
								} else if (this.state.radioPaymentType === 2) {
									this.getQrCode(order_id)
								} else if (this.state.radioPaymentType === 3) {
									
									
									this.setState({ ...this.state, switch: true });
									
									await axios({
										url: API_CONFIG.base_url + "/payments/getResponseBackEndEfectivo",
										method: 'post',
										data: {
											DocIdentidadAsesor: this.state.DocIdentidadAsesor,
											id_orden: order_id
										}
									}).then(response => response.data)
										.then(data => {
											if (data.resp==="x"){
												refreshing = false;

												console.log("error")
												this.setState({ ...this.state, switch: false, orderPaid: true, isExecuting:false, messageError: data.desc+ " - "+ 
													(  data.respCobro?.message?.Mensaje?data.respCobro?.message?.Mensaje:""  ) 
												});
											}else{
												console.log("ok")
												this.setState({ ...this.state, switch: false, orderPaid: true, isExecuting:false });
											}
											console.log(data)
									})
									
									
									console.log("registrando compra")
									//this.
								}
							} else {
								this.setState({ ...this.state, showError: true, descResponse: data.descResponse, isExecuting: false });
							}
						})
				} else {
					this.setState({ ...this.state, buttonMessage: "Confirmar Pago", isExecuting: false, processingPayment: false });
				}
			}
		}
	}

	getPaymentStatus = async () => {

		if (this.state.radioPaymentType !== 3) {
			var resp = await getPaymentStatus(this.state.shopCartSessionID);

			if (resp.response == "E") {
				if (resp.descResponse == "PAGADO") {
					this.setState({ ...this.state, buttonMessage: "Pedido Pagado", orderPaid: true });
					refreshing = false;
				} else if (resp.descResponse == "ERROR") {
					refreshing = false;
					this.setState({ ...this.state, buttonMessage: "Pedido no Procesado", messageOrder: resp.descResponse + (resp.responseBackend ? "," + resp.responseBackend : ""), orderError: true });
					//console.log("error!")
				}
			} else {
				refreshing = false;
				this.setState({ ...this.state, buttonMessage: "Pedido no Procesado", messageOrder: resp.descResponse, orderError: true });
				//console.log("error!")
			}
			tryOuts++
			if (tryOuts > this.state.maxTryOuts) {
				//console.log("timeout!")
				refreshing = false;
				this.setState({ ...this.state, buttonMessage: "Tiempo expirado", orderTimeOut: true });
			}
		}
	}

	getQrCode = async (order_id) => {
		if (!this.state.generatedqrCode) {
			this.setState({ ...this.state, isExecuting: true, cardDisabled: true });
			var date = new Date();
			date = new Date(date.getTime() + (date.getTimezoneOffset() * 60 * 1000));
			var mes = "", dia = "";
			var anio = date.getFullYear();
			if (date.getMonth() === 0) {
				mes = "01"
			} else if (date.getMonth() < 9) {
				mes = "0" + (date.getMonth() + 1);
			} else {
				mes = (date.getMonth() + 1);
			}
			if (date.getDate() < 10) {
				dia = "0" + date.getDate();
			} else {
				dia = date.getDate() + ""
			}
			var expirationDate = anio + "-" + mes + "-" + dia;
			
			await axios.post(
				API_CONFIG.base_url + "/payments/getQRPaymentCodeBCP", 
				{ 
					"currency": "BOB",
				  "amount": this.state.amount,
				  "gloss": "PAGO SERVICIO:" + this.state.productId + "(" + this.state.amount + "), ORDEN:" + order_id,
				  "serviceCode": "050",
				  "businessCode": "0228",
				  "expiration": "00/00:00",
				  "collectors": [
				    {
				      "name": "PEDIDO 1",
				      "parameter": "2",
				      "value": {}
				    }
				  ], 
				  "order_id" : order_id
				}
			).then(response => response.data)
			.then(data => {
				console.log(data);
				//this.setState({ defQR: data.qr });
				this.setState({ defQR: data.qr?data.qr:data.data.qrImage });
				this.setState({ ...this.state, modalConfirm: false, isExecuting: false, qrDisabled: true, buttonMessage: "Esperando Pago", switch: true, generatedqrCode: true });
			})
			
	 /*
			await axios.post(
				API_CONFIG.qr_api,
				//"http://localhost:2001/payments/getQRPaymentCodeBNB",
				{
					//"QueryCompanyId": "103",
					"currency": "BOB",
					"gloss": "PAGO SERVICIO:" + this.state.productId + "(" + this.state.amount + "), ORDEN:" + order_id,
					"amount": this.state.amount,

					"singleUse": true,
					"expirationDate": expirationDate,
					"callback_url": process.env.REACT_APP_CALLBACK_QR,
					"callback_method":"post"
					 
				}
			)
			
				.then(response => response.data)
				.then(data => {
					//console.log(data);
					//this.setState({ defQR: data.qr });
					this.setState({ defQR: data.qr?data.qr:data.data.qrImage });
					this.setState({ ...this.state, modalConfirm: false, isExecuting: false, qrDisabled: true, buttonMessage: "Esperando Pago", switch: true, generatedqrCode: true });
				})
				*/
		}
	}

	executePaymentCyber = async (order_id) => {
console.log("executePaymentCyber")
		var data = {
			amount: this.state.amount,
			email: this.state.email,
			phone: this.state.phone,
			card_name: this.state.card_name,
			card_lastname: this.state.card_lastname,
			card_number: this.state.card_number,
			month: this.state.card_month,
			year: this.state.card_year,
			cvv: this.state.cvv,
			referenceNumber: order_id,
			ci: this.state.ci_cliente,
			nit: this.state.nit?this.state.nit:this.state.ci_cliente
		}

		let url = API_CONFIG.base_url + '/payments/getTokenCyber';
		let token = "";
		await axios({
			url: url,
			data: data,
			method: 'post'
		})
			.then(response => response.data)
			.then(data => {
				//console.log(data)

				this.setState({ ...this.state, token: data.token });

			}).then(async () => {
				this.setState({ ...this.state, showFrame: true, switch: true });
				this.setState({ isExecuting: false, modalConfirm:false });
			});


	}

	toggleConfirm = () => {
		this.setState({
			modalConfirm: !this.state.modalConfirm
		});
	}
	render() {
		return (
			<div>
				{this.state.modalConfirm &&
					<MDBModal isOpen={this.state.modalConfirm} centered toggle={this.toggleConfirm}>

						<MDBModalHeader>
								<h3>
									Confirmaci&oacute;n  de Venta
								</h3>
							</MDBModalHeader>
						<MDBModalBody>

						

							<MDBContainer>

								<MDBRow style={{marginTop:20}}>
									<MDBCol md="12" mt="1" >
										<div style={{fontSize:18}}>
										&iquest;Desea proceder con la venta del plan  <span style={{textDecoration:"underline", fontWeight:"bold" }}>{this.state.nombre_producto}</span>  por el valor de Bs. {this.state.amount}?
										</div>
										{/*this.state.messageError? &&
											<div className="ml-1 mt-1 mr-1 alert alert-danger alert-dismissible fade show" role="alert">
					              				<h4 className="alert-heading">Error registrando pago</h4>
					                			<p><i className="fas fa-exclamation-circle mr-2" />{this.state.messageError} </p>
											</div>  
										*/}
					           			
										
										
									</MDBCol>
								</MDBRow>
							</MDBContainer>
						</MDBModalBody>
						<MDBModalFooter>
								
								<button type="button"
									className="btn btn-outline-secondary submit-btn"
									onClick={this.toggleConfirm}>Cancelar </button>

								<button type="button"
									className="btn btn-primary submit-btn"
									onClick={this.executePayment.bind(this)}>
									{this.state.processingPayment ?
										<div className="spinner-border spinner-border-sm" role="status">
											<span className="sr-only ml-2">Loading...</span>
										</div> : ""}
									<span className="ml-2"> Confirmar </span> </button>
						</MDBModalFooter>
					</MDBModal>
				}

				

				<Loader idLoading={this.state.isExecuting} />
				{this.state.showFrame ?
					<div className="content" >
						<div className="container">
							<div className="row" id="paymentForm" >
								<div className="col-md-7 col-lg-8">
									<div className="card">
										<div className="card-body">
											<iframe width={this.state.windowWidth < 500 ? "300" : "620"} height={this.state.windowWidth < 500 ? "400" : "420"} style={{ "borderStyle": "none" }} src={API_CONFIG.base_url + "/payments/getPaymentCyber/" + this.state.token}></iframe>
										</div>
									</div>
								</div>


								<div className="col-md-5 col-lg-4 theiaStickySidebar">
									<div className="card booking-card">
										<div className="card-header">
											<h4 className="card-title">Detalle a Pagar </h4>
										</div>
										<div className="card-body">
											<div className="booking-doc-info">
												<Link to="/patient/doctor-profile" className="booking-doc-img">
													<img src={IMG01} alt="User" />
												</Link>
												<div className="booking-info">
													<h4><Link to="/patient/doctor-profile">{this.state.nombre_producto}</Link></h4>
													<div className="rating">
														<i className="fas fa-star filled"></i>
														<i className="fas fa-star filled"></i>
														<i className="fas fa-star filled"></i>
														<i className="fas fa-star filled"></i>
														<i className="fas fa-star"></i>
														<span className="d-inline-block average-rating">35</span>
													</div>
												</div>
											</div>
											<div className="booking-summary">
												<div className="booking-item-wrap">
													{/*	
													<ul className="booking-date">
														<li>Fecha <span>{this.state.fechaActual}</span></li>
														<li>Hora <span>{this.state.horaActual}</span></li>
													</ul>
													*/}
													{this.state.costo === 0 ? "" :
														<ul className="booking-fee">
															<li>Costo del {this.state.productType} <span>{"Bs." + this.state.costo}</span></li>
															{/*	<li>RC. IVA <span>Bs.45,50</span></li> */}
															<li>Descuento <span>{"Bs." + this.state.descuento}</span></li>
														</ul>
													}
													<div className="booking-total">
														<ul className="booking-total-list">
															<li>
																<span>Total</span>
																<span className="total-cost">{"Bs." + this.state.amount}</span>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
					: ""}

				{this.state.orderPaid ?
					<Redirect
						to={{
							pathname: "/patient/booking-success/" + this.state.productType + "/" + this.state.productId,
							search: "t=" + this.state.paymentKey
						}}
					/> : ""
				}

				{this.state.orderError ?
					<Redirect
						to={{
							pathname: "/patient/booking-error/" + this.state.productType,
							search: "t=" + this.state.paymentKey + "&messageOrder=" + this.state.messageOrder
						}}
					/> : ""
				}
				{this.state.orderTimeOut ?
					<Redirect
						to={{
							pathname: "/patient/booking-timeout/" + this.state.productType,
							search: "t=" + this.state.paymentKey
						}}
					/> : ""
				}


				<ToastContainer hideProgressBar={true} newestOnTop={false} position={"bottom-right"} autoClose={3000} />

				{!this.state.showFrame ?
					<div className="content">
						<div className="container">

							<div className="row" id="paymentForm" >
								<div className="col-md-7 col-lg-8">
									<div className="card">
										<div className="card-body">

											<div>
												{/*
										
										*/}


												{this.state.DocIdentidadAsesor ?
													<div className="info-widget">
														<h4 className="card-title">Datos del Vendedor</h4>
														<div className="row">
															<div className="col-12 col-sm-12 col-lg-3">
																<div className=" ">
																	<span style={{ fontWeight: 'bold' }}>Nombre:</span>
																</div>
															</div>
															<div className="col-6 col-sm-12 col-lg-9">
																<div className=" ">
																	<span style={{ fontWeight: 'bold' }}>
																		{this.state.nombreAsesor + " CI:" + this.state.DocIdentidadAsesor}
																	</span>
																</div>
															</div>
														</div>
														{/*
															<small>
																En caso de que sean los mismos datos de titular <a style={{ textDecoration: "underline" }} href="#div_ci_cliente"

																	onClick={this.defData}


																> Autogenerar Datos </a>
															</small>
															*/}
													</div>
													: ""
												}

												{/*Datos del Contratante */}
												<div className="info-widget" >
													<h4 className="card-title">Datos del Contratante</h4>


													<div className="row"  >
														<div className="col-md-6 col-sm-12">

															<div className="form-group card-label" >
																<label>Tipo Persona (*)</label>
																<select defaultValue={this.state.tipo} id="tipo" name="tipo" onChange={this.changeHandler} 
																	className={"form-control " + (this.state.validation[9].invalid ? "is-invalid" : "")}>
																	<option value="N">Natural</option>
																	<option value="J">Juridica</option>
																</select>
															</div>

														</div>
														<div className="col-md-6 col-sm-12" style={{ /*display: 'flex', alignItems: 'center'*/ }}>
															<div className="form-group card-label" >
																<label>Nit (*)</label>
																<input
																	name="nit"
																	className={"form-control " + (this.state.validation[7].invalid ? "is-invalid" : "")}
																	type="text" value={this.state.nit} onChange={this.changeHandler} />
															</div>
															{/** 
															 * <div className="form-group card-label" style={{ width: '70%' }}>
																<label>Nit (*)</label>
																<input
																	name="nit"
																	className={"form-control " + (this.state.validation[7].invalid ? "is-invalid" : "")}
																	type="text" value={this.state.nit} onChange={this.changeHandler} />
															</div>
															
															<div className=" ml-1" style={{ width: '40%' }}>
																<button type="button" style={{ height: 50, marginTop: -7, width: '96%' }}
																	className="btn  btn-info submit-btn"
																	onClick={this.searchContratante}>
																	<span>  Buscar </span>
																</button>
															</div>
															*/}
														</div>
													</div>

													<div className="row">
														<div className="col-12">
															<div className="form-group card-label">
																<label>Nombre para la Factura (*)</label>
																<input
																	name="nombre_factura"
																	className={"form-control " + (this.state.validation[6].invalid ? "is-invalid" : "")} type="text"
																	value={this.state.nombre_factura} onChange={this.changeHandler} />
															</div>
														</div>
													</div>

													<div className="row">
														<div className="col-md-6 col-sm-12" style={{ display: 'flex' }}>
															<div className="form-group card-label" style={{ width: '60%' }}>
																<label>Carnet Identidad  (*)</label>
																<input disabled={this.state.lockPatientInfo && this.state.productType == "atencion"}
																	className={"form-control " + (this.state.validation[0].invalid ? "is-invalid" : "")} type="text"
																	name="ci_cliente" value={this.state.ci_cliente} onChange={this.changeHandler} />
															</div>

															<div className="form-group card-label ml-1" style={{ width: '20%' }}>
																<label>Ext.  </label>
																<input className={"form-control"} type="text" name="extension"
																	value={this.state.extension} onChange={this.changeHandler} />
															</div>

															<div className="form-group card-label ml-1" style={{ width: '20%' }}>
																<label>Exp.	  </label>
																<select defaultValue={this.state.expedicion}
																	id="expedicion" name="expedicion"
																	onChange={this.changeHandler} className={"form-control " + (this.state.validation[8].invalid ? "is-invalid" : "")}>
																	{this.state.v_extension_T.map(item => (
																		<option selected={item.value == this.state.expedicion ? true : false}
																			value={item.value}>{item.text}</option>
																	))
																	}
																</select>
															</div>
														</div>
														<div className="col-md-6 col-sm-12">
															<div className="form-group card-label">
																<label>Nombres  (*)</label>
																<input
																	disabled={this.state.lockPatientInfo}
																	className={"form-control " + (this.state.validation[1].invalid ? "is-invalid" : "")}
																	type="text"
																	name="user_name"
																	value={this.state.user_name} onChange={this.changeHandler} />
															</div>
														</div>
													</div>
													<div className="row">


														<div className="col-md-6 col-sm-12">
															<div className="form-group card-label">
																<label>Apellido Paterno  (*)</label>
																<input
																	disabled={this.state.lockPatientInfo}
																	className={"form-control " + (this.state.validation[2].invalid ? "is-invalid" : "")}
																	type="text"
																	name="last_name"
																	value={this.state.last_name} onChange={this.changeHandler} />
															</div>
														</div>
														<div className="col-md-6 col-sm-12">
															<div className="form-group card-label">
																<label>Apellido Materno</label>
																<input
																	disabled={this.state.lockPatientInfo} className={"form-control "}
																	type="text"
																	name="last_name_2"
																	value={this.state.last_name_2} onChange={this.changeHandler} />
															</div>
														</div>
													</div>


													<div className="row">
														<div className="col-md-6 col-sm-12">
															<div className="form-group card-label">
																<span className="ml-2" style={{ color: "#757575" }}>
																	Sexo del paciente (*)
																</span>
																<MDBFormInline>
																	<label className="ml-2">
																		<input disabled={this.state.lockPatientInfo}
																			type="radio"
																			name="radioGenero" checked={this.state.radioGenero === 0 ? true : false} onClick={this.onClickRadioGen(0)} />
																		<span className="checkmark ml-1">Mujer</span>
																	</label>
																	<label className="ml-2">
																		<input
																			disabled={this.state.lockPatientInfo}
																			type="radio"
																			name="radioGenero" checked={this.state.radioGenero === 1 ? true : false} onClick={this.onClickRadioGen(1)} />
																		<span className="checkmark ml-1">Hombre</span>
																	</label>
																</MDBFormInline>
															</div>
														</div>
														<div className="col-md-6 col-sm-12">
															<div className="form-group card-label">
																<span className="ml-2" style={{ color: "#757575" }}>
																	Fecha de Nacimiento (*)
																</span>
																<MDBFormInline>
																	<label className="ml-2">
																		<select defaultValue={this.state.day} style={{ "padding": "0px 0px" }} id="day" name="day" 
																		onChange={this.changeHandler} className={"form-control " + (this.state.validation[3].invalid ? "is-invalid" : "")}>
																			{this.state.v_days.map(item => (
																				<option selected={item.value == this.state.day ? true : false} value={item.value}>{item.text}</option>
																			))
																			}
																		</select>
																	</label>
																	<label className="ml-2">
																		<select defaultValue={this.state.month} style={{ "padding": "0px 0px" }} id="month" name="month" 
																		onChange={this.changeHandler} className={"form-control " + (this.state.validation[4].invalid ? "is-invalid" : "")}>
																			{this.state.v_months.map(item => (
																				<option selected={item.value == this.state.month ? true : false} value={item.value}>{item.text}</option>
																			))
																			}
																		</select>
																	</label>
																	<label className="ml-2">
																		<select defaultValue={this.state.year} style={{ "padding": "0px 0px" }} id="year" name="year" 
																		onChange={this.changeHandler} className={"form-control " + (this.state.validation[5].invalid ? "is-invalid" : "")}>
																			{this.state.v_years.map(item => (
																				<option selected={item.value == this.state.year ? true : false} value={item.value}>{item.text}</option>
																			))
																			}
																		</select>
																	</label>
																</MDBFormInline>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-md-6 col-sm-12">
															<div className="form-group card-label">
																<label>Tel&eacute;fono celular</label>
																<input disabled={this.state.lockPatientInfo}
																	className={"form-control"}
																	type="text"
																	name="phone" value={this.state.phone} onChange={this.changeHandler} />
															</div>
														</div>
														<div className="col-md-6 col-sm-12">
															<div className="form-group card-label">
																<label>Correo electr&oacute;nico</label>
																<input className={"form-control"}
																	type="email"
																	name="email"
																	value={this.state.email} onChange={this.changeHandler} />
															</div>
														</div>
													</div>

													<div className="row">
														<div className="col-md-6 col-sm-12">
															<div className="form-group card-label"> 
															 	<label>Pais (*)</label>
																		<select defaultValue={this.state.pais}
																			 
																			id="pais"
																			name="pais"
																			onChange={this.changeHandler}
																			className={"form-control " + (this.state.validation[10].invalid ? "is-invalid" : "")}>
																			{this.state.paises.map(item => (
																				<option selected={item == this.state.pais ? true : false} value={item}>{item}</option>
																			))
																			}
																		</select>
																 
															</div>
														</div>
														<div className="col-md-6 col-sm-12">
															<div className="form-group card-label">
															<label>Ciudad (*)</label>
															 	{this.state.pais==="BOLIVIA" ?
														 
																	<select defaultValue={this.state.ciudad}
																		 
																			id="ciudad"
																			name="ciudad"
																			onChange={this.changeHandler}
																			className={"form-control " + (this.state.validation[11].invalid ? "is-invalid" : "")}>
																			{this.state.ciudades.map(item => (
																				<option selected={item.value == this.state.ciudad ? true : false} 
																				value={item.value}>{item.text}</option>
																			))
																			}
																		</select>
																 :
																		<input className={"form-control " + (this.state.validation_T[11].invalid ? "is-invalid" : "")} 
																		type="text" name="ciudad" 
																		value={this.state.ciudad} 
																		onChange={this.changeHandler} />
																}
															</div>
														</div>
													</div>
													
													<div className="row">
														<div className="col-md-6 col-sm-12">
															<div className="form-group card-label">
																<label>Ocupaci&oacute;n</label>
																<input className={"form-control"}
																	type="text"
																	name="ocupacion"
																	value={this.state.ocupacion} onChange={this.changeHandler} />
															</div>
														</div>
														<div className="col-md-6 col-sm-12">
															<div className="form-group card-label">
																<label>Estado Civil (*)</label>
																	<select defaultValue={this.state.estadocivil}
																	 
																		id="estadocivil"
																		name="estadocivil"
																		value={this.state.estadocivil}
																		onChange={this.changeHandler}
																		className={"form-control"}>
																		{this.state.estadoscivil.map(item => (
																			<option selected={item.value == this.state.estadocivil ? true : false} value={item.value}>{item.text}</option>
																		))
																		}
																	</select>
															</div>
														</div>
													</div>

													<div className="row">
														<div className="col-12">
															<div className="form-group card-label">
																<label>Direcci&oacute;n</label>
																<input
																	name="direccion"
																	className={"form-control"}
																	type="text"
																	value={this.state.direccion} onChange={this.changeHandler} />
															</div>
														</div>
													</div>

												</div>

												{/*Datos del Titular */
													this.state.productType === "atencion" || this.state.productType === "plan" ?
														<div className="info-widget" id="div_ci_cliente">
															<h4 className="card-title">Datos del Titular</h4>

															<small>
																En caso de que sean los mismos datos de titular <a style={{ textDecoration: "underline" }} href="#div_ci_cliente"

																	onClick={this.setTitularOnContratante}


																> Haga click Aqui </a>
															</small>

															<div className="row">
																<div className="col-md-6 col-sm-12" style={{ display: 'flex' }}>
																	<div className="form-group card-label" style={{ width: '50%' }}>
																		<label>Carnet Identidad  (*)</label>
																		<input className={"form-control " + (this.state.validation_T[0].invalid ? "is-invalid" : "")} type="text" name="titular_ci_cliente" value={this.state.titular_ci_cliente} onChange={this.changeHandler_T} />
																	</div>

																	<div className="form-group card-label ml-1" style={{ width: '25%' }}>
																		<label>Ext.  </label>
																		<input className={"form-control"} type="text" name="titular_extension" value={this.state.titular_extension} onChange={this.changeHandler_T} />
																	</div>

																	<div className="form-group card-label ml-1" style={{ width: '25%' }}>
																		<label>Exp.	  </label>
																		<select defaultValue={this.state.titular_expedicion} id="titular_expedicion" name="titular_expedicion" onChange={this.changeHandler_T} className={"form-control " + (this.state.validation_T[8].invalid ? "is-invalid" : "")}>
																			{this.state.v_extension_T.map(item => (
																				<option selected={item.value == this.state.titular_expedicion ? true : false} value={item.value}>{item.text}</option>
																			))
																			}
																		</select>
																	</div>

																</div>
																<div className="col-md-6 col-sm-12">
																	<div className="form-group card-label">
																		<label>Nombres  (*) </label>
																		<input className={"form-control " + (this.state.validation_T[1].invalid ? "is-invalid" : "")} type="text" name="titular_user_name" value={this.state.titular_user_name} onChange={this.changeHandler_T} />
																	</div>
																</div>
																<div className="col-md-6 col-sm-12">
																	<div className="form-group card-label">
																		<label>Apellido Paterno (*)</label>
																		<input className={"form-control " + (this.state.validation_T[2].invalid ? "is-invalid" : "")} type="text" name="titular_last_name" value={this.state.titular_last_name} onChange={this.changeHandler_T} />
																	</div>
																</div>
																<div className="col-md-6 col-sm-12">
																	<div className="form-group card-label">
																		<label>Apellido Materno</label>
																		<input className={"form-control "} type="text" name="titular_last_name_2" value={this.state.titular_last_name_2} onChange={this.changeHandler_T} />
																	</div>
																</div>
															</div>
															<div className="row">
																<div className="col-md-6 col-sm-12">
																	<div className="form-group card-label">
																		<span className="ml-2" style={{ color: "#757575" }}>
																			Sexo del paciente (*)
																		</span>
																		<MDBFormInline>
																			<label className="ml-2">
																				<input type="radio" name="titular_radioGenero" checked={this.state.titular_radioGenero === 0 ? true : false} onClick={this.onClickRadioGen_T(0)} />
																				<span className="checkmark ml-1">Mujer</span>
																			</label>
																			<label className="ml-2">
																				<input type="radio" name="titular_radioGenero" checked={this.state.titular_radioGenero === 1 ? true : false} onClick={this.onClickRadioGen_T(1)} />
																				<span className="checkmark ml-1">Hombre</span>
																			</label>
																		</MDBFormInline>
																	</div>
																</div>
																<div className="col-md-6 col-sm-12">
																	<div className="form-group card-label">
																		<span className="ml-2" style={{ color: "#757575" }}>
																			Fecha de Nacimiento (*)
																		</span>
																		<MDBFormInline>
																			<label className="ml-2">
																				<select defaultValue={this.state.titular_day} style={{ "padding": "0px 0px" }} id="titular_day" name="titular_day" 
																				onChange={this.changeHandler_T} className={"form-control " + (this.state.validation_T[3].invalid ? "is-invalid" : "")}>
																					{this.state.v_days_T.map(item => (
																						<option selected={item.value == this.state.titular_day ? true : false} value={item.value}>{item.text}</option>
																					))
																					}
																				</select>
																			</label>
																			<label className="ml-2">
																				<select defaultValue={this.state.titular_month} style={{ "padding": "0px 0px" }} id="titular_month" name="titular_month" 
																				onChange={this.changeHandler_T} className={"form-control " + (this.state.validation_T[4].invalid ? "is-invalid" : "")}>
																					{this.state.v_months_T.map(item => (
																						<option selected={item.value == this.state.titular_month ? true : false} value={item.value}>{item.text}</option>
																					))
																					}
																				</select>
																			</label>
																			<label className="ml-2">
																				<select defaultValue={this.state.titular_year} style={{ "padding": "0px 0px" }} id="titular_year" name="titular_year" 
																				onChange={this.changeHandler_T} className={"form-control " + (this.state.validation_T[5].invalid ? "is-invalid" : "")}>
																					{this.state.v_years_T.map(item => (
																						<option selected={item.value == this.state.titular_year ? true : false} value={item.value}>{item.text}</option>
																					))
																					}
																				</select>
																			</label>
																		</MDBFormInline>
																	</div>
																</div>

															</div>

															<div className="row">
																<div className="col-md-6 col-sm-12">
																	<div className="form-group card-label">
																		<label>Tel&eacute;fono celular</label>
																		<input className={"form-control"} type="text" name="titular_phone" value={this.state.titular_phone} onChange={this.changeHandler_T} />
																	</div>
																</div>
																<div className="col-md-6 col-sm-12">
																	<div className="form-group card-label">
																		<label>Correo electr&oacute;nico</label>
																		<input className={"form-control"} type="email" name="titular_email" value={this.state.titular_email} onChange={this.changeHandler_T} />
																	</div>
																</div>
															</div>

														

															<div className="row">
																<div className="col-md-6 col-sm-12">
																	<div className="form-group card-label">
																	 
																		<label>Pais (*)</label>
																		 
																				<select defaultValue={this.state.titular_pais}   id="titular_pais" 
																				name="titular_pais" onChange={this.changeHandler_T} 
																				className={"form-control " + (this.state.validation_T[7].invalid ? "is-invalid" : "")}>
																					{this.state.paises.map(item => (
																						<option selected={item == this.state.titular_pais ? true : false} value={item}>{item}</option>
																					))
																					}
																				</select>
																		 
																	</div>
																</div>
																<div className="col-md-6 col-sm-12">
																	<div className="form-group card-label">
																		<span className="ml-2" style={{ color: "#757575" }}>
																			
																		</span>
																		<label>Ciudad (*)</label>
																	 		{this.state.titular_pais==="BOLIVIA" ?
														 
																				<select defaultValue={this.state.titular_ciudad}   id="titular_ciudad" name="titular_ciudad" onChange={this.changeHandler_T} 
																					className={"form-control " + (this.state.validation_T[8].invalid ? "is-invalid" : "")}>
																					{this.state.ciudades.map(item => (
																						<option selected={item.value == this.state.titular_ciudad ? true : false} value={item.value}>{item.text}</option>
																					))
																					}
																				</select>
																			 :
																					<input className={"form-control " + (this.state.validation_T[8].invalid ? "is-invalid" : "")} 
																					type="text" name="titular_ciudad" 
																					value={this.state.titular_ciudad} 
																					onChange={this.changeHandler_T} />
																			} 
																	</div>
																</div>
															</div>
															
															<div className="row">
																<div className="col-md-6 col-sm-12">
																	<div className="form-group card-label">
																		<label>Ocupaci&oacute;n</label>
																		<input className={"form-control"}
																			type="text"
																			name="titular_ocupacion"
																			value={this.state.titular_ocupacion} onChange={this.changeHandler_T} />
																	</div>
																</div>
																<div className="col-md-6 col-sm-12">
																	<div className="form-group card-label">
																		<label>Estado Civil (*)</label>
																			<select defaultValue={this.state.titular_estadocivil}
																			 
																				id="titular_estadocivil"
																				name="titular_estadocivil"
																				onChange={this.changeHandler_T}
																				value={this.state.titular_estadocivil}
																				className={"form-control " + (this.state.validation_T[9].invalid ? "is-invalid" : "")}>
																				{this.state.estadoscivil.map(item => (
																					<option selected={item.value == this.state.titular_estadocivil ? true : false} value={item.value}>{item.text}</option>
																				))
																				}
																			</select>
																	</div>
																</div>
															</div>
															
															<div className="row">
																<div className="col-md-12 col-sm-12">
																	<div className="form-group card-label">
																		<label>Direcci&oacute;n</label>
																		<input className={"form-control"} type="text" name="titular_direccion" value={this.state.titular_direccion} onChange={this.changeHandler_T} />
																	</div>
																</div>
															</div>

															{this.state.tieneBenef==1 &&
																<div className="row mb-2 mt-2">
																	<div className="col-md-12 col-sm-12 text-right">

																		<button type="button"
																			href="#reservationForm"
																			disabled={this.state.hideAddBeneficiario}
																			className="btn btn-sm btn-success submit-btn"
																			onClick={this.showAddBeneficiario}>
																			<span>  Agregar Beneficiario </span> </button>

																	</div>
																</div>
															}
															
															{this.state.v_beneficiarios.length > 0 ?
																<div className="row">
																	<div className="col-md-12 col-sm-12 text-left">

																		<h4 className="card-title">Lista de Beneficiarios</h4>

																		<table className="table table-hover table-top table-striped">
																			<thead>
																				<tr>
																					<th scope="col">Carnet de Identidad</th>
																					<th scope="col">Nombre</th>
																					<th scope="col">Tel&eacute;fono</th>
																					<th scope="col">Accion </th>
																				</tr>
																			</thead>
																			<tbody>
																				{this.state.v_beneficiarios.map(item => (
																					<tr key={"row" + item.id_producto}>
																						<td className="col-text-right" data-title="Nombre">
																							{item.benef_ci_cliente}
																						</td>
																						<td className="col-text-right" data-title="Carnet de Identidad">
																							{item.benef_user_name}
																						</td>
																						<td className="col-text-right" data-title="Tel&eacute;fono">
																							{item.benef_phone}
																						</td>
																						<td className="col-text-right" data-title="Editar">
																							<button type="button"
																								href="#reservationForm"
																								className="btn btn-sm btn-success"
																								style={{ width: 'auto' }}
																								name={item.benef_ci_cliente}
																								onClick={this.showEdifBeneficiario}>
																								<i className="fas fa-edit" />
																							</button>
																							<button type="button"
																								href="#reservationForm"
																								className="btn btn-sm btn-danger"
																								style={{ width: 'auto' }}
																								name={item.benef_ci_cliente}
																								onClick={this.deleteBeneficiario}>
																								<i className="fas fa-trash" />
																							</button>
																						</td>
																					</tr>
																				))
																				}
																			</tbody>
																		</table>
																	</div>
																</div>
																: ""}
															<DialogBenef open={this.state.modalB}
																icon="fas fa-plus"
																cancelButton={true}
																toggle={this.toggleB}
																title="Registrar Beneficiario"
																validation_B={this.state.validation_B}
																v_extension_T={this.state.v_extension_T}
																v_days_T={this.state.v_days_T}
																v_months_T={this.state.v_months_T}
																v_years_T={this.state.v_years_T}
																paises={this.state.paises}
																ciudades={this.state.ciudades}
																parentescos={this.state.parentescos}
																benef_radioGenero={this.state.benef_radioGenero}
																changeHandler_B={this.changeHandler_B}
																onClickRadioGen_B={this.onClickRadioGen_B}

																benef_extension={this.state.benef_extension}
																benef_expedicion={this.state.benef_expedicion}
																benef_ci_cliente={this.state.benef_ci_cliente}
																benef_id_cliente={this.state.benef_id_cliente}
																benef_user_name={this.state.benef_user_name}
																benef_last_name={this.state.benef_last_name}
																benef_last_name_2={this.state.benef_last_name_2}
																benef_email={this.state.benef_email}
																benef_phone={this.state.benef_phone}
																benef_day={this.state.benef_day}
																benef_month={this.state.benef_month}
																benef_year={this.state.benef_year}
																benef_direccion={this.state.benef_direccion}
																benef_ciudad={this.state.benef_ciudad}
																benef_pais={this.state.benef_pais}
																benef_parentesco={this.state.benef_parentesco}
																 
																benef_ocupacion={this.state.benef_ocupacion}
																benef_estadocivil={this.state.benef_estadocivil}
																estadoscivil={this.state.estadoscivil}



																buttons={this.state.buttonsModalB} />

														</div>
														: ""
												}												
											</div>
										</div>
									</div>

								</div>

								<div className="col-md-5 col-lg-4 theiaStickySidebar">
									<div className="card booking-card">
										<div className="card-header">
											<h4 className="card-title">Detalle a Pagar </h4>
										</div>
										<div className="card-body">
											<div className="booking-doc-info">
												<Link to="/patient/doctor-profile" className="booking-doc-img">
													<img src={IMG01} alt="User" />
												</Link>
												<div className="booking-info">
													<h4><Link to="/patient/doctor-profile">{this.state.nombre_producto}</Link></h4>
													<div className="rating">
														<i className="fas fa-star filled"></i>
														<i className="fas fa-star filled"></i>
														<i className="fas fa-star filled"></i>
														<i className="fas fa-star filled"></i>
														<i className="fas fa-star"></i>
														<span className="d-inline-block average-rating">95%</span>
													</div>
												</div>
											</div>
											<div className="booking-summary">
												<div className="booking-item-wrap">
													{/*	
											<ul className="booking-date">
												<li>Fecha <span>{this.state.fechaActual}</span></li>
												<li>Hora <span>{this.state.horaActual}</span></li>
											</ul>
											*/}
													{this.state.costo === 0 ? "" :
														<ul className="booking-fee">
															<li>Costo del {this.state.productType} <span>{"Bs." + this.state.costo}</span></li>
															{/*	<li>RC. IVA <span>Bs.45,50</span></li> */}
															<li>Descuento <span>{"Bs." + this.state.descuento}</span></li>
														</ul>
													}
													<div className="booking-total">
														<ul className="booking-total-list">
															<li>
																<span>Total</span>
																<span className="total-cost">{"Bs." + this.state.amount}</span>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
						{(this.state.DocIdentidadAsesor || process.env.REACT_APP_onlineShop) &&
						<div className="container">
						<div className="row" id="paymentForm2" > 
							<div className="col-12 col-md-7 col-lg-8">
								<div className="card">
									<div className="card-body"> 
										<div className="payment-widget">
											<h4 style={{borderBottom: "2px solid #bab6b6",lineHeight: "2.5rem" }} className="card-title">M&eacute;todo de Pago</h4>


												<div className="payment-list">
													 
														<label className="payment-radio credit-card-option">
															<input type="radio" name="radio" defaultChecked onClick={this.onClickRadio(1)} />
															<span className="checkmark"></span>
															Tarjeta de Cr&eacute;dito/D&eacute;bito
														</label>
														<small>*Debes habilitar tu tarjeta para pagos por Internet </small>
 														
														{this.state.radioPaymentType === 1 ?
															<>
																<div className="row">
																	<div className="col-md-6">
																		<div className="form-group card-label">
																			<label htmlFor="card_name">Nombre del Titular de la tarjeta</label>
																			<input className={"form-control " + (this.state.validation2[0].invalid ? "is-invalid" : "")} id="card_name" type="text" name="card_name" value={this.state.card_name} onChange={this.changeHandler_C} />
																		</div>
																	</div>
																	<div className="col-md-6">
																		<div className="form-group card-label">
																			<label htmlFor="card_lastname">Apellido del Titular de la tarjeta</label>
																			<input className={"form-control " + (this.state.validation2[1].invalid ? "is-invalid" : "")} id="card_lastname" type="text" name="card_lastname" value={this.state.card_lastname} onChange={this.changeHandler_C} />
																		</div>
																	</div>
																</div>
																<div className="row">

																	<div className="col-md-6">
																		<div className="form-group card-label">
																			<label htmlFor="card_number">N&uacute;mero de Tarjeta</label>
																			<input className={"form-control " + (this.state.validation2[2].invalid ? "is-invalid" : "")} id="card_number" type="text" name="card_number" value={this.state.card_number} onChange={this.changeHandler_C} />
																		</div>
																	</div>

																	<div className="col-md-2">
																		<div className="form-group card-label" >
																			<label>Mes</label>
																			<select defaultValue={this.state.card_month} id="card_month" name="card_month" onChange={this.changeHandler_C} className={"form-control " + (this.state.validation2[3].invalid ? "is-invalid" : "")}>
																				<option value="">Mes</option>
																				<option value="01">Enero</option>
																				<option value="02">Febrero</option>
																				<option value="03">Marzo</option>
																				<option value="04">Abril</option>
																				<option value="05">Mayo</option>
																				<option value="06">Junio</option>
																				<option value="07">Julio</option>
																				<option value="08">Agosto</option>
																				<option value="09">Septiembre</option>
																				<option value="10">Octubre</option>
																				<option value="11">Noviembre</option>
																				<option value="12">Diciembre</option>
																			</select>
																		</div>
																	</div>
																	<div className="col-md-2">
																		<div className="form-group card-label">
																			<label> A&ntilde;o </label>
																			<select defaultValue={this.state.card_year} id="card_year" name="card_year" onChange={this.changeHandler_C} className={"form-control " + (this.state.validation2[4].invalid ? "is-invalid" : "")}>
																				<option value="">A&ntilde;o</option>
																				<option value="2022">2022</option>
																				<option value="2023">2023</option>
																				<option value="2024">2024</option>
																				<option value="2025">2025</option>
																				<option value="2026">2026</option>
																				<option value="2027">2027</option>
																				<option value="2028">2028</option>
																				<option value="2029">2029</option>
																			</select>
																		</div>
																	</div>
																	<div className="col-md-2">
																		<div className="form-group card-label">
																			<label htmlFor="cvv">CVV</label>
																			<input className={"form-control " + (this.state.validation2[5].invalid ? "is-invalid" : "")} id="cvv" type="password" name="cvv" value={this.state.cvv} onChange={this.changeHandler_C} />
																		</div>
																	</div>
																</div>
															</>
															: ""}
													</div>

													
													<div className="payment-list">
														<label className="payment-radio paypal-option">
															<input type="radio" name="radio" defaultChecked onClick={this.onClickRadio(2)} />
															<span className="checkmark"></span>
															Pago QR
														</label>

														{this.state.radioPaymentType === 2 ?
															<div className="col-md-12" style={{textAlign: "center", padding: 0}}>
																<img style={{width:"auto", maxWidth:"auto"}} src={`data:image/jpeg;base64,${this.state.defQR}`} width={this.state.qrDim}  height={this.state.qrDim} />
															</div>
															: ""}

													</div>
													
													{/*this.state.DocIdentidadAsesor ?
														<div className="payment-list">
															<label className="payment-radio paypal-option">
																<input type="radio" name="radio" defaultChecked onClick={this.onClickRadio(3)} />
																<span className="checkmark"></span>
																Pago Efectivo

																<div className="col-md-12" style={{textAlign: "center", padding: 0}}>
																	<img style={{width:"auto", maxWidth:"auto"}} src={qrTempImg} width={this.state.qrDim}  height={this.state.qrDim} />
																</div>
															</label>
															{this.state.radioPaymentType === 3 ?
																<div className="col-md-12">
																	Recuerde que puede hacer seguimiento de sus ventas en los reporte de seguimiento
																</div>
																: ""}

														</div>
															: ""*/}

													{/*this.state.DocIdentidadAsesor ?
														<div className="payment-list">
															<label className="payment-radio paypal-option">
																<input type="radio" name="radio" onClick={this.onClickRadio(3)} />
																<span className="checkmark"></span>
																Pago en Efectivo
															</label>
															{this.state.radioPaymentType === 3 ?
																<div className="col-md-12">
																	Recuerde que puede hacer seguimiento de sus ventas en los reporte de seguimiento
																</div>
																: ""}

														</div>
															: ""*/}
													{/*
													<div className="payment-list">
														<label className="payment-radio paypal-option">
															<input type="radio" name="radio" />
															<span className="checkmark"></span>
															Tigo Money
														</label>
													</div>
													*/}
													<div className="terms-accept">
														<div className="custom-checkbox">
															<input onClick={this.onClickTerminos} type="checkbox" id="terms_accept" />
															<label htmlFor="terms_accept">He le&iacute;do y aceptado los <a href="/terms" value="x" target="_blank" >T&eacute;rminos &amp; Condiciones</a></label>
														</div>

													</div>
													{this.state.mensaje_facturacion ?
														<small><b>Estimado Cliente: </b> {this.state.mensaje_facturacion} </small>
														: ""}


													{this.state.showWarning ?
														<div className="alert alert-warning alert-dismissible fade show" role="alert">
															<strong>Advertencia!</strong> Complete todo los datos
															<button type="button" className="close" data-dismiss="alert" aria-label="Close">
																<span aria-hidden="true">x</span>
															</button>
														</div> : ""}

													{this.state.showError ?
														<div className="alert alert-warning alert-dismissible fade show" role="alert">
															<strong>Error!</strong> {this.state.errorMessage}
															<button type="button" className="close" data-dismiss="alert" aria-label="Close">
																<span aria-hidden="true">x</span>
															</button>
														</div> : ""}
														
															<div className="submit-section mt-4">
																<button type="button"
																	href="#reservationForm"
																	disabled={this.state.disabledPayButton}
																	className="btn btn-primary submit-btn"
																	onClick={ this.validatePaymentForm}>
																	{this.state.processingPayment ?
																		<div className="spinner-border spinner-border-sm" role="status">
																			<span className="sr-only ml-2">Loading...</span>
																		</div> : ""}
																	<span className="ml-2"> {this.state.buttonMessage} </span> </button>
															</div>		
												</div>

												</div>
											</div>
										</div>
									</div>
								</div>			
						}

					</div>
					: ""}

			</div>
		);
	}
}

export default Checkout;